import { render } from "./QuizHeader.vue?vue&type=template&id=69621720&scoped=true"
import script from "./QuizHeader.vue?vue&type=script&lang=js"
export * from "./QuizHeader.vue?vue&type=script&lang=js"

import "./QuizHeader.vue?vue&type=style&index=0&id=69621720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69621720"]])

export default __exports__